var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 20.6777H12H21","stroke":"#2C3F5B","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.2217 5.82843L17.1715 10.7781M12.2217 5.82843L15.0502 3L19.9999 7.94975L17.1715 10.7781L12.2217 5.82843ZM12.2217 5.82843L6.61516 11.435C6.42763 11.6225 6.32227 11.8769 6.32227 12.1421V16.6776H10.8578C11.123 16.6776 11.3773 16.5723 11.5649 16.3847L17.1715 10.7781L12.2217 5.82843Z","stroke":"#2C3F5B","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Edit.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Edit;

Edit.default = Edit;
